module.exports = __webpack_public_path__ + "static/header-bg@2x-3397ffc121340d8b31fe5284a07d9a2e.jpg";